@use "@design/design-tokens/typography/typography" as *;
@use "@design/design-tokens/border-radius/border-radius" as *;
@use "@design/components/custom-scroll/custom-scroll" as *;

.root {
  display: flex;
  flex-direction: column;
}

.rootWithActions {
  flex: 1;
  min-height: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.formScrollable {
  @include custom-scroll-minimal;

  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fieldLabelRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.fieldLabel {
  @include typography-v2-body-sm;
}

.titleInputWrapper {
  [data-input-wrapper] {
    @include border-radius-r2;
    min-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }

  input {
    min-height: 40px;
    box-sizing: border-box;
  }
}

.queryEditor {
  width: 100%;

  :global(.CodeMirror) {
    min-height: 150px;
    background-color: transparent;
    border: 1px solid var(--border-default);
    @include border-radius-r2;
    box-sizing: border-box;

    &:hover {
      border-color: var(--border-hover);
    }
  }

  &:focus-within :global(.CodeMirror) {
    border-color: var(--border-primary);
  }

  :global(.EasyMDEContainer),
  :global(.CodeMirror-scroll) {
    min-height: 150px;
  }
}

.queryEditorError {
  :global(.CodeMirror) {
    border-color: var(--border-critical);

    &:hover {
      border-color: var(--border-critical);
    }
  }

  &:focus-within :global(.CodeMirror) {
    border-color: var(--border-critical);
  }
}

.queryMentionEditor {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 12px;
  background-color: transparent;
  border: 1px solid var(--border-default);
  @include border-radius-r2;
  box-sizing: border-box;
  cursor: text;

  &:hover {
    border-color: var(--border-hover);
  }

  &:focus-within {
    border-color: var(--border-primary);
  }

  // `flex: none` is required: the shared editor is a `flex: 1 1 0%` child,
  // so `flex-basis: 0` overrides `height` below unless `flex` is reset too.
  [data-testid$='-editor'] {
    flex: none;
    height: 150px;
    max-height: 150px;
  }

  &.queryMentionEditorFullscreen {
    width: 860px;

    [data-testid$='-editor'] {
      height: 600px;
      max-height: 600px;
    }
  }
}

.queryMentionInput {
  padding-right: 20px;
}

.queryMentionFullscreenWrapper {
  display: flex;
  justify-content: center;
}

.queryMentionExpandButton {
  position: absolute;
  right: 8px;
  bottom: 8px;
}

.queryMentionExpandIcon {
  display: inline-flex;
  width: 16px;
  height: 16px;
}

.queryMentionEditorError {
  border-color: var(--border-critical);

  &:hover {
    border-color: var(--border-critical);
  }

  &:focus-within {
    border-color: var(--border-critical);
  }
}

.scheduleToggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.scheduleToggleFlex {
  display: flex;
  align-items: center;
  gap: 8px;
}

.scheduleToggleLine {
  flex: 1;
  min-width: 0;
  height: 1px;
  background-color: var(--border-soft);
}

.scheduleToggleLabel {
  @include typography-v2-body-base;
  margin: 0;
}

.scheduleToggleTooltipTarget {
  display: inline-flex;
}

.nextRun {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  margin: 0;
}

.fieldError {
  @include typography-v2-body-sm;
  color: var(--text-critical);
  margin: 0;
}

.footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 0 0;
  flex-shrink: 0;
}

.footerButton {
  @include border-radius-r3;
  height: 40px;
  min-height: 40px;
}

.footerCancelButton {
  flex-shrink: 0;
}

.footerSubmitButton {
  flex: 1;
  min-width: 0;
}
